<template>
    <v-container class="my-5">
        <!--     Dialog para Mostrar mensaje "Seleccionar al menos un día de la Semana"       -->
        <v-dialog
                v-model="dialogAtLeastOneDay"
                max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('aviso')}}
                </v-card-title>
                <v-card-text>
                    {{$t('msg_no_days')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="dialogAtLeastOneDay = false"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Registro del Directorio     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_court')}}
                </v-card-title>
                <v-card-text>
                <v-alert
                    text
                    type="info"
                >{{$t('msg_warning_court')}}</v-alert>
                <v-alert
                    text
                    type="error"
                >{{$t('msg_accion_deshacer')}}</v-alert>
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteCourt()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Clausurar Canchas     -->
        <v-dialog
                v-model="closureDialog"
                max-width="450"
        >
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{ $t('close_court') }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="closureDialog = false"
                    ><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-autocomplete
                        v-model="motive"
                        prepend-icon="mdi-close-box-multiple"
                        name="motive"
                        item-text="name"
                        item-value="id"
                        :label="'*' + $t('motive')"
                        :placeholder="$t('choose_motive')"
                        :error-messages="errores.status"
                        :items="motives"
                        no-data-text="Ningún Resultado"
                        autocomplete="off"
                    >
                    </v-autocomplete>
                  </v-row>
                  <v-row>
                    <v-col cols="6" md="6">
                      <v-flex sm12>
                        {{ $t('closing_start_date_time') }}
                        <v-menu
                            v-model="menuCalendar"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="computedDateFormatted"
                                :label="$t('Fecha')"
                                hint="DD/MM/YYYY"
                                persistent-hint
                                prepend-icon="mdi-sort-calendar-ascending"
                                :error-messages="errores.start_time"
                                readonly
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="date"
                              no-title
                              :min="getCurrentDate()"
                              :locale="$t('region')"
                              @input="menuCalendar = false"
                          ></v-date-picker>
                        </v-menu>
                        </v-flex>
                        <v-flex sm12>
                        {{ $t('closing_end_date_time') }}
                        <v-menu
                            v-model="menuCalendarExpiration"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="computedDateExpirationFormatted"
                                :label="$t('Fecha')"
                                hint="DD/MM/YYYY"
                                persistent-hint
                                prepend-icon="mdi-sort-calendar-descending"
                                :error-messages="errores.end_time"
                                readonly
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateExpiration"
                              no-title
                              :min="getCurrentDate()"
                              :locale="$t('region')"
                              @input="menuCalendarExpiration = false"
                          ></v-date-picker>
                        </v-menu>
                        </v-flex>
                    </v-col>
                    <v-col cols="6" md="6">
                      <v-flex xs12>
                        <br>
                        <v-menu
                            ref="menuCheckInTimeClosure"
                            v-model="menuCheckInTimeClosure"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="checkInTimeClosure"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="checkInTimeClosure"
                                :label="$t('Hora')"
                                prepend-icon="mdi-sort-clock-ascending"
                                :error-messages="errores.start_time"
                                readonly
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                              v-if="menuCheckInTimeClosure"
                              v-model="checkInTimeClosure"
                              scrollable
                              format="24hr"
                              @click:minute="$refs.menuCheckInTimeClosure.save(checkInTimeClosure)"
                          ></v-time-picker>
                        </v-menu>
                        </v-flex>
                        <v-flex xs12>
                          <br>
                        <v-menu
                            ref="menuCheckOutTimeClosure"
                            v-model="menuCheckOutTimeClosure"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="checkOutTimeClosure"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="checkOutTimeClosure"
                                :label="$t('Hora')"
                                prepend-icon="mdi-sort-clock-descending"
                                :error-messages="errores.end_time"
                                readonly
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                              v-if="menuCheckOutTimeClosure"
                              v-model="checkOutTimeClosure"
                              scrollable
                              format="24hr"
                              @click:minute="$refs.menuCheckOutTimeClosure.save(checkOutTimeClosure)"
                          ></v-time-picker>
                        </v-menu>
                        </v-flex>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="closureDialog = false"
                    >
                        {{$t('cancelar')}}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="closeCourt()"
                    >
                        {{$t('close_court')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('courts') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="750">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                color="primary"
                                v-on="on"
                                @click="update = false, getSport() ,cleanFields()"
                        >
                            + {{$t('add_directory')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                        @submit.prevent="update
                            ? updateCourt(idUpdate)
                            : addCourt()"
                >
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('courts') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false"
                            ><v-icon>mdi-close</v-icon></v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6" md="6">
                                    <v-autocomplete
                                            v-if="dialog" autofocus
                                            v-model="idSport"
                                            prepend-icon="mdi-football"
                                            name="idSport"
                                            item-text="name"
                                            item-value="id"
                                            :label="$t('sport')"
                                            :placeholder="$t('choose_sport')"
                                            :error-messages="errores.idSport"
                                            :items="sports"
                                            no-data-text="Ningún Resultado"
                                            clearable
                                            autocomplete="off"
                                            :disabled="update"
                                    >
                                    </v-autocomplete>
                                    <v-text-field
                                            v-model="name"
                                            name="name"
                                            prepend-icon="mdi-soccer-field"
                                            :label="$t('nombre')"
                                            counter
                                            maxlength="200"
                                            :error-messages="errores.name"
                                    ></v-text-field>
                                    <v-autocomplete
                                        v-model="time_interval"
                                        prepend-icon="mdi-timelapse"
                                        name="time_interval"
                                        item-text="name"
                                        item-value="id"
                                        :label="'*' + $t('reservation_time')"
                                        :placeholder="$t('choose_time')"
                                        :error-messages="errores.time_interval"
                                        :items="timeIntervals"
                                        no-data-text="Ningún Resultado"
                                        autocomplete="off"
                                    >
                                    </v-autocomplete>
                                    <v-autocomplete
                                        v-model="court_type"
                                        prepend-icon="mdi-vector-difference-ab"
                                        name="court_type"
                                        item-text="name"
                                        item-value="id"
                                        :label="'*' + $t('Tipo')"
                                        :placeholder="$t('choose_type')"
                                        :error-messages="errores.court_type"
                                        :items="courtTypes"
                                        no-data-text="Ningún Resultado"
                                        clearable
                                        autocomplete="off"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="6" md="6">
                                  <v-row>
                                    <v-col cols="6" md="6">
                                        <v-flex>
                                            <v-menu
                                                ref="menuCheckInTime"
                                                v-model="menuCheckInTime"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="checkInTime"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="checkInTime"
                                                    :label="$t('opening_time')"
                                                    prepend-icon="mdi-sort-clock-descending"
                                                    :error-messages="errores.opening_time"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="menuCheckInTime"
                                                    v-model="checkInTime"
                                                    scrollable
                                                    format="24hr"
                                                    @click:minute="$refs.menuCheckInTime.save(checkInTime)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-col>
                                    <v-col cols="6" md="6">
                                        <v-flex>
                                            <v-menu
                                                ref="menuCheckOutTime"
                                                v-model="menuCheckOutTime"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                :return-value.sync="checkOutTime"
                                                transition="scale-transition"
                                                offset-y
                                                max-width="290px"
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="checkOutTime"
                                                    :label="$t('closing_time')"
                                                    prepend-icon="mdi-sort-clock-ascending"
                                                    :error-messages="errores.closing_time"
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                                </template>
                                                <v-time-picker
                                                    v-if="menuCheckOutTime"
                                                    v-model="checkOutTime"
                                                    scrollable
                                                    format="24hr"
                                                    @click:minute="$refs.menuCheckOutTime.save(checkOutTime)"
                                                ></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-col>
                                  </v-row>
                                    <v-flex>
                                        <v-label>{{ $t('access_days') }}</v-label>
                                        <v-container fluid>
                                            <v-layout row>
                                            <v-checkbox
                                                color="primary"
                                                v-model="Monday"
                                                :label="$t('Lunes')"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                                color="primary"
                                                v-model="Tuesday"
                                                :label="$t('Martes')"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                                color="primary"
                                                v-model="Wednesday"
                                                :label="$t('Miercoles')"
                                                hide-details
                                            ></v-checkbox>
                                            </v-layout>
                                            <v-layout row>
                                            <v-checkbox
                                                color="primary"
                                                v-model="Thursday"
                                                :label="$t('Jueves')"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                                color="primary"
                                                v-model="Friday"
                                                :label="$t('Viernes')"
                                                hide-details
                                            ></v-checkbox>
                                            <v-checkbox
                                                color="primary"
                                                v-model="Saturday"
                                                :label="$t('Sabado')"
                                                hide-details
                                            ></v-checkbox>
                                            </v-layout>
                                            <v-layout row>
                                            <v-checkbox
                                                color="primary"
                                                v-model="Sunday"
                                                :label="$t('Domingo')"
                                                hide-details
                                            ></v-checkbox>
                                            </v-layout>
                                        </v-container>
                                    </v-flex>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                            <v-spacer/>
                            <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                            <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{ $t('courts') }}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            clearable
                            append-icon="mdi-magnify"
                            :label="$t('search_by_name')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingDataCourts"
                        :items="courts"
                        multi-sort
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                >
                    <template v-slot:item.inhabited="{ item }">
                        <v-icon
                                v-if="item.inhabited === true"
                                medium
                                color="primary"
                                class="mr-2"
                        >
                            mdi-check
                        </v-icon>
                        <v-icon
                                v-if="item.inhabited === false"
                                medium
                                color="red"
                                class="mr-2"
                        >
                            mdi-close
                        </v-icon>
                        {{ item.inhabited ? $t('habitada') : $t('deshabitada') }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="gray"
                                        class="mr-2"
                                        @click="fillFields(item), update = true, dialog = true, idUpdate = item.id"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <span>{{$t('change')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="deleteDialog = true, idDirectoryDelete = item.id"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                            <span>{{$t('delete')}}</span>
                        </v-tooltip>
                        <!-- <v-tooltip bottom v-if="item.status === 2 || item.status === 3">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="green"
                                        class="mr-2"
                                        @click="deleteDialog = true, idDirectoryDelete = item.id"
                                >
                                    mdi-check-circle
                                </v-icon>
                            </template>
                            <span>{{$t('open_court')}}</span>
                        </v-tooltip> -->
                        <v-tooltip bottom v-if="item.status === 1 || item.status === 4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="closureDialog = true, idDirectoryDelete = item.id, cleanFieldsClosure()"
                                >
                                    mdi-key-remove
                                </v-icon>
                            </template>
                            <span>{{$t('close_court')}}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:item.opening_time="{ item }">
                        {{item.opening_time.slice(0, -3)}}
                    </template>
                    <template v-slot:item.closing_time="{ item }">
                        {{item.closing_time.slice(0, -3)}}
                    </template>
                    <template v-slot:item.status="{ item }">
                        <v-chip
                            v-if="item.status === 1"
                            label
                            color="success"
                            dark
                        >
                            <v-icon>
                                mdi-check
                            </v-icon>
                            {{$t('open')}}
                        </v-chip>
                        <v-chip
                            v-else-if="item.status === 2"
                            label
                            color="error"
                            dark
                        >
                            <v-icon left>
                                mdi-cancel
                            </v-icon>
                            {{$t('closed_due_to_rain')}}
                        </v-chip>
                        <v-chip
                            v-else-if="item.status === 3"
                            label
                            color="error"
                            dark
                        >
                            <v-icon left>
                                mdi-cancel
                            </v-icon>
                            {{$t('closed_due_to_lightning_storm')}}
                        </v-chip>
                        <v-chip
                            v-else-if="item.status === 4"
                            label
                            color="green"
                            dark
                        >
                            <v-icon left>
                                mdi-cancel
                            </v-icon>
                            {{$t('open_with_damaged_greens')}}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'

Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'courts',
  created () {
    this.getSport()
    this.getStaff()
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    computedDateExpirationFormatted () {
      return this.formatDate(this.dateExpiration)
    },
    ...mapGetters(['getProfile']),
    ...mapState(['language'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    name: '',
    nameAux: '',
    header: [],
    loadingDataCourts: false,
    loading: false,
    sports: [],
    idSport: '',
    courts: [],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    closureDialog: false,
    file: null,
    rules: [
      value => !value || value.type === 'application/vnd.ms-excel' || 'Archivo con formato incorrecto.'
    ],
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
    days: '',
    days_aux: '',
    dialogAtLeastOneDay: false,
    checkInTime: '',
    checkInTime_aux: '',
    menuCheckInTime: '',
    checkOutTime: '',
    checkOutTime_aux: '',
    menuCheckOutTime: '',
    menuCheckInTimeClosure: '',
    menuCheckOutTimeClosure: '',
    checkInTimeClosure: '',
    checkOutTimeClosure: '',
    headers: [],
    menuCalendar: false,
    menuCalendarExpiration: false,
    date: '',
    date_aux: '',
    dateExpiration: '',
    dateExpiration_aux: '',
    time_interval: 10,
    timeIntervals: [
      {
        id: 10,
        name: '10 minutos'
      },
      {
        id: 20,
        name: '20 minutos'
      },
      {
        id: 30,
        name: '30 minutos'
      },
      {
        id: 40,
        name: '40 minutos'
      },
      {
        id: 50,
        name: '50 minutos'
      },
      {
        id: 60,
        name: '60 minutos'
      }
    ],
    court_type: '',
    courtTypes: [
      {
        id: 1,
        name: 'Principal'
      },
      {
        id: 2,
        name: 'Practica'
      }
    ],
    motive: 2,
    motives: [
      {
        id: 2,
        name: 'Cerrado por lluvia'
      },
      {
        id: 3,
        name: 'Cerrado por tormenta eléctrica'
      }
    ]
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        sortable: false,
        value: 'action'
      },
      {
        text: this.$t('sport'),
        align: 'center',
        sortable: true,
        value: 'sport.name'
      },
      {
        text: this.$t('nombre'),
        align: 'center',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('opening_time'),
        align: 'center',
        sortable: true,
        value: 'opening_time'
      },
      {
        text: this.$t('closing_time'),
        align: 'center',
        sortable: true,
        value: 'closing_time'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'status'
      }
    ]
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    getCurrentDate () {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
    },
    getDays () {
      this.days = ''

      if (this.Monday) {
        this.days = '0'
      }
      if (this.Tuesday) {
        this.days += '1'
      }
      if (this.Wednesday) {
        this.days += '2'
      }
      if (this.Thursday) {
        this.days += '3'
      }
      if (this.Friday) {
        this.days += '4'
      }
      if (this.Saturday) {
        this.days += '5'
      }
      if (this.Sunday) {
        this.days += '6'
      }
    },
    AtLeastOneDay () {
      var count = 0

      if (this.Monday) {
        count++
      }
      if (this.Tuesday) {
        count++
      }
      if (this.Wednesday) {
        count++
      }
      if (this.Thursday) {
        count++
      }
      if (this.Friday) {
        count++
      }
      if (this.Saturday) {
        count++
      }
      if (this.Sunday) {
        count++
      }
      return count
    },
    getStaff () {
      this.loadingDataCourts = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/courts/by-housing-unit/' + this.getProfile.idHousingUnit,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.courts = response.data
          this.loadingDataCourts = false
        })
        .catch(error => {
          this.loadingDataCourts = false
          console.log(error)
        })
    },
    getSport () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/sport/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.sports = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    addCourt () {
      if (this.AtLeastOneDay() === 0) {
        this.dialogAtLeastOneDay = true
      } else {
        this.loading = true
        this.errores = []
        let weekdays = ''
        this.getDays()
        weekdays = this.days
        var bodyFormData = new FormData()
        bodyFormData.set('idSport', this.idSport)
        bodyFormData.set('name', this.name)
        bodyFormData.set('opening_time', this.checkInTime)
        bodyFormData.set('closing_time', this.checkOutTime)
        bodyFormData.set('opening_days', weekdays)
        bodyFormData.set('court_type', this.court_type)
        bodyFormData.set('time_interval', this.time_interval)
        bodyFormData.set('IdHousingUnit', this.getProfile.idHousingUnit)
        const config = {
          method: 'post',
          url: 'https://clubtest.intrare.app/courts/',
          headers: {
            'Content-Type': 'multipart/form-data',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('court_created_successfully'))
            this.dialog = false
            this.getStaff()
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
                console.log(this.errores.phone2)
              }
              if (error.response.data.non_field_errors) {
                this.errorsPhone = error.response.data.non_field_errors
              }
            }
          })
      }
    },
    updateCourt (id) {
      this.loading = true
      this.errores = []
      this.errorsPhone = []
      var weekdays = ''

      var bodyFormData = new FormData()

      this.getDays()
      weekdays = this.days
      if (this.name !== this.nameAux) {
        bodyFormData.set('name', this.name)
      }
      if (this.days_aux !== weekdays) {
        bodyFormData.set('opening_days', weekdays)
      }
      if (this.checkInTime_aux !== this.checkInTime) {
        bodyFormData.set('opening_time', this.checkInTime)
      }
      if (this.checkOutTime_aux !== this.checkOutTime) {
        bodyFormData.set('closing_time', this.checkOutTime)
      }
      bodyFormData.set('court_type', this.court_type)
      bodyFormData.set('time_interval', this.time_interval)
      const config = {
        method: 'patch',
        url: 'https://clubtest.intrare.app/courts/' + id + '/',
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getStaff()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('court_updated_successfully'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    deleteCourt () {
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/courts/' + this.idDirectoryDelete,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Cancha con ID = ', this.idDirectoryDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('court_deleted_successfully'))
        this.getStaff()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    openCourt () {
      const config = {
        method: 'delete',
        url: ' https://clubtest.intrare.app/closures/' + this.idDirectoryDelete + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Cancha con ID = ', this.idDirectoryDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('court_deleted_successfully'))
        this.getStaff()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    closeCourt () {
      this.loading = true
      this.errores = []
      const config = {
        method: 'post',
        url: 'https://clubtest.intrare.app/closures/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          start_time: this.date + ' ' + this.checkInTimeClosure,
          end_time: this.dateExpiration + ' ' + this.checkOutTimeClosure,
          court_id: this.idDirectoryDelete,
          status: this.motive
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('court_closed_successfully'))
          this.closureDialog = false
          this.getStaff()
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
              console.log(this.errores.phone2)
            }
            if (error.response.data.non_field_errors) {
              this.errorsPhone = error.response.data.non_field_errors
            }
          }
        })
    },
    timeNow () {
      var d = new Date()
      var h = (d.getHours() < 10 ? '0' : '') + d.getHours()
      var m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
      this.checkInTime = h + ':' + m
      this.checkOutTime = h + ':' + m
    },
    cleanFields () {
    //   this.timeNow()
      this.checkInTime = ''
      this.checkOutTime = ''
      this.idSport = ''
      this.name = ''
      this.Monday = false
      this.Tuesday = false
      this.Wednesday = false
      this.Thursday = false
      this.Friday = false
      this.Saturday = false
      this.Sunday = false
      this.time_interval = 10
      this.court_type = ''
    },
    cleanFieldsClosure () {
      this.errores = []
      this.date = ''
      this.dateExpiration = ''
      this.checkInTimeClosure = ''
      this.checkOutTimeClosure = ''
      this.motive = 2
    },
    fillDays (days) {
      this.Monday = false
      this.Tuesday = false
      this.Wednesday = false
      this.Thursday = false
      this.Friday = false
      this.Saturday = false
      this.Sunday = false
      if (days.length > 0) {
        if (days.includes('0') === true) {
          this.Monday = true
        }
        if (days.includes('1') === true) {
          this.Tuesday = true
        }
        if (days.includes('2') === true) {
          this.Wednesday = true
        }
        if (days.includes('3') === true) {
          this.Thursday = true
        }
        if (days.includes('4') === true) {
          this.Friday = true
        }
        if (days.includes('5') === true) {
          this.Saturday = true
        }
        if (days.includes('6') === true) {
          this.Sunday = true
        }
      } else {
        this.Monday = false
        this.Tuesday = false
        this.Wednesday = false
        this.Thursday = false
        this.Friday = false
        this.Saturday = false
        this.Sunday = false
      }
    },
    fillFields (item) {
      this.name = item.name
      this.nameAux = item.name
      this.idSport = item.sport.id
      this.court_type = item.court_type
      this.time_interval = item.time_interval
      this.fillDays(item.opening_days)
      this.days_aux = item.opening_days
      this.checkInTime = item.opening_time.slice(0, -3)
      this.checkInTime_aux = item.opening_time.slice(0, -3)
      this.checkOutTime = item.closing_time.slice(0, -3)
      this.checkOutTime_aux = item.closing_time.slice(0, -3)
    },
    clear: function () {
      this.errores = []
      this.errorsPhone = []
      this.$store.commit('snackbar_change_color', 'success')
      // this.$validator.reset()
      this.$store.commit('snackbar_activate_false')
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
.edge {
    border-radius: 8px;
    border-color: #2a2738 #2a2738 #2a2738 #2a2738;
    border-width: 3px 3px 3px 3px;
    text-align: center;
    border-style: solid solid solid solid;
}
</style>
